import { scheduledLegSchema } from './scheduledLeg';

export const scheduleDiffSchema = {
	title: 'last unseen changes of the schedule',
	version: 4,
	type: 'object',
	primaryKey: 'scheduledLegId',
	properties: {
		...scheduledLegSchema.properties,
		updateState: { type: 'string' },
	},
	required: ['scheduledLegId'],
};
